import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const getById = (id) =>
  requestsTemplates.get(mainPath, `/employees/${id}`);
